import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, ProtectedRoute } from "./context/AuthContext";
import Landing from "./pages/Landing";
import AuthPage from "./pages/AuthPage";
import Dashboard from "./pages/Dashboard";
import EventEditor from "./pages/EventEditor";
import EventAdmin from "./pages/EventAdmin";
import GuestPage from "./pages/GuestPage";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import DoorCheckIn from "./pages/DoorCheckIn";
import DoorImport from "./pages/DoorImport";
import CohostAccept from "./pages/CohostAccept";

const guard = (el) => <ProtectedRoute>{el}</ProtectedRoute>;

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<AuthPage mode="login" />} />
          <Route path="/signup" element={<AuthPage mode="signup" />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/cohost/accept" element={<CohostAccept />} />
          <Route path="/dashboard" element={guard(<Dashboard />)} />
          <Route path="/events/new" element={guard(<EventEditor />)} />
          <Route path="/events/:id/edit" element={guard(<EventEditor />)} />
          <Route path="/events/:id/door" element={guard(<DoorCheckIn />)} />
          <Route path="/events/:id/import" element={guard(<DoorImport />)} />
          <Route path="/events/:id" element={guard(<EventAdmin />)} />
          <Route path="/e/:slug" element={<GuestPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </AuthProvider>
  );
}

export default App;
